const Global = {};

Global.width = 640; // 640
Global.height = 640; // 480
Global.app = null;
Global.world = null;
Global.game = null;

export default Global;